import { DateRangePickerTextField } from "@styleguide";
import { type Control, Controller, useWatch } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../logics/resolver";

interface IModalSocialOfferFormFieldPeriodProps {
  control: Control<TModalSocialOfferFormResolver>;
}

export const ModalSocialOfferFormFieldPeriod = ({ control }: IModalSocialOfferFormFieldPeriodProps) => {
  const permanent = useWatch({ name: "permanent", control });

  return (
    permanent === "temporary" && (
      <Controller
        control={control}
        name="serviceDates"
        render={({ field: { value, onChange, onBlur }, fieldState: { error, isDirty } }) => {
          const dateError = isDirty && (!value?.startDate || !value?.endDate);
          const helperText = () => {
            if (isDirty && !value?.startDate && !value?.endDate) {
              return "Ce champ est obligatoire";
            }
            if (isDirty && !value?.startDate) {
              return "La date de début est obligatoire";
            }
            if (isDirty && !value?.endDate) {
              return "La date de fin est obligatoire";
            }
          };

          return (
            <DateRangePickerTextField
              label="Période *"
              value={value ?? { startDate: null, endDate: null }}
              onChange={onChange}
              onBlur={onBlur}
              error={dateError || !!error}
              helperText={dateError ? helperText() : error?.message}
              required={{ startDate: true, endDate: true }}
            />
          );
        }}
      />
    )
  );
};
